<p-card styleClass="app-frame ds-beta" role="region" aria-labelledby="titleregion">
  <p-header>
        <div id="titleregion" class="p-col-12 ACA_TabRow">         
          <section-title [contentKey]="'acc_accountInfoForm_label_loginInfo'" [admin]="adminMode" [viewId]="viewId"
            [module]="module"></section-title>
          <h5 class="signup-stepcounter"><strong>{{this.getStepText()}}</strong></h5>
          <section-instructions [contentKey]="'acc_accountInfoForm_label_loginInfo|sub'" [admin]="adminMode" [viewId]="viewId"
          [module]="module"></section-instructions>
        </div>
  </p-header>
  <form *ngIf="AccountForm" (ngSubmit)="submitRegistration(AccountForm.value)" fieldMatchValidator
    [formGroup]="AccountForm" controlName="txbPassword1" matchingControlName="txbPassword2" class="cardContent">
    <span class="required p-ml-1"><icon class="accelicons accelicons-asterisk" aria-label="*"></icon> Required Fields</span>
    <aca-page-layout-display *ngIf="!adminMode" [controlGroup]="AccountForm" (onchkChange)="validateReqSMSCheckbox($event)"></aca-page-layout-display>
    <aca-admin-page-layout *ngIf="adminMode" class="p-d-flex p-flex-wrap" [module]="module"
      [viewId]="viewId" permissionLevel="USERREGISTRATION" permissionValue=""></aca-admin-page-layout>
    <br />
    <div id="div_cbDisclaimer" class="checkboxInput">
      <p-checkbox ariaLabel="cbDisclaimer" id="cbDisclaimer" binary="true" ariaLabelledBy="cbDisclaimerLabel"
        [(ngModel)]="disclaimerAccepted" name="cbDisclaimer" [ngModelOptions]="{standalone: true}"
        [disabled]="adminMode"></p-checkbox>
      <label class="p-checkbox-label" for="cbDisclaimer" id="cbDisclaimerLabel">{{this.checkBxLabelText}} <a target="newAdmin" rel="noopener noreferrer" class="linktext pointCursor" 
        i18n="Terms of Service (opens in new window) | Disclaimer Accepted Checkbox Label start"
        (click)="navigateToDisclaimer()"
          >Terms of Service </a><icon class="linktext accelicons accelicons-open-in"></icon></label>
    </div>    
    <div id="captcha" class="captcha p-mb-4 p-mt-4" *ngIf="recaptchaLoaded && RecaptchaInfo?.IsCaptchaEnabledForRegistration">
    <aca-recaptcha [RecaptchaPublicKey]="RecaptchaInfo?.RecaptchaPublicKey" (verifyUser)="updateRecaptchaStatus($event)"></aca-recaptcha>
  </div>
</form>

    <div class="p-mt-4">
      <accela-button-primary i18n-label label="Continue" [disabled]="!RecaptchaInfo || adminMode" accessButton="3"
        (onClicked)="this.submitRegistration(AccountForm.value)" pRipple>
      </accela-button-primary>
      <hr class="separator p-mt-4 p-mb-4" />
      <accela-button-secondary i18n-label label="Back" (click)="this.back()" accessButton="b" [disabled]="this.adminMode" pRipple></accela-button-secondary>
      <input type="submit" value="submit" style="visibility: hidden" accesskey="3" />
    </div>
    <!-- <aca-form-debugger [form]="this.AccountForm"></aca-form-debugger> -->
</p-card>
